import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const GiftIcon: React.FC<React.PropsWithChildren<Props>> = props => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      d="M16.5054 18.1843C16.4573 18.6981 16.0259 19.0909 15.5098 19.0909H5.39926C4.88314 19.0909 4.4518 18.6981 4.40363 18.1843L3.63635 10H17.2727L16.5054 18.1843Z"
      fill="none"
      stroke="#697180"
      strokeMiterlimit="10"
    />
    <path
      d="M18.3818 9.18658C18.2921 9.65845 17.8797 9.99992 17.3994 9.99992H3.5097C3.0294 9.99992 2.61693 9.65845 2.52728 9.18658L2.04364 6.64113C1.92658 6.02503 2.39895 5.45447 3.02607 5.45447H17.883C18.5101 5.45447 18.9825 6.02503 18.8654 6.64113L18.3818 9.18658Z"
      fill="none"
      stroke="#697180"
      strokeMiterlimit="10"
    />
    <path
      d="M10.3239 5.80249V19.4389"
      fill="none"
      stroke="#697180"
      strokeMiterlimit="10"
    />
    <path
      d="M10 5.45448C10 5.45448 10.6772 2.35243 12.2895 1.91852C13.9019 1.4846 15.0708 2.50938 14.305 3.98655C13.5391 5.46371 10.0081 5.45448 10.0081 5.45448H10Z"
      fill="none"
      stroke="#697180"
      strokeMiterlimit="10"
    />
    <path
      d="M10 5.33104C10 5.33104 9.12303 0.850554 6.31174 0.909637C3.50045 0.96872 4.43481 4.70082 6.41009 5.19318C8.38537 5.68554 10 5.33104 10 5.33104V5.33104Z"
      fill="none"
      stroke="#697180"
      strokeMiterlimit="10"
    />
  </svg>
);

export default GiftIcon;
